export default __webpack_public_path__ + "static/media/main.48edc077.png";